<template>
  <div class="game-container" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <a class="back-button" @click="goBack">⬅ {{back_label[language]}}</a>

    <!-- Game Stats (Round, Timer, Score) -->
    <div class="game-stats">
      <div class="game-info">{{ Round_label[language] }}: {{ Math.min(round + 1, maxRounds + 1) }} / {{ maxRounds + 1 }}</div>
      <div class="timer">{{ timeleft_label[language] }}: {{ timeLeft }}s</div>
      <div class="score">{{score_label[language]}}: {{ score }}</div>
    </div>

    <!-- Food Images -->
    <div id="food-container">
    <div v-for="(food, index) in foods" :key="index" class="food-item">
    <!-- Food Image -->
    <img :src="food.src" @click="checkSelection(food)" class="food-image" />

    <!-- Food Name -->
    <div class="food-name">{{ food.name[language] }}</div>
  </div>
</div>


    <MorningWinOverlay :message="overlayMessage[language]" :visible="isMorningWinOverlayVisible" />
    <MorningLoseOverlay :message="overlayMessage[language]" :visible="isMorningLoseOverlayVisible" />
    <NoonWinOverlay :message="overlayMessage[language]" :visible="isNoonWinOverlayVisible" />
    <NoonLoseOverlay :message="overlayMessage[language]" :visible="isNoonLoseOverlayVisible" />
    <AfternoonWinOverlay :message="overlayMessage[language]" :visible="isAfternoonWinOverlayVisible" />
    <AfternoonLoseOverlay :message="overlayMessage[language]" :visible="isAfternoonLoseOverlayVisible" />
    <EveningWinOverlay :message="overlayMessage[language]" :visible="isEveningWinOverlayVisible" />
    <EveningLoseOverlay :message="overlayMessage[language]" :visible="isEveningLoseOverlayVisible" />
    <ProfPepOverlay :message="overlayMessage[language]" :visible="isOverlayVisible" @start-game="onStartGame" />

    <!-- Badge for Success/Fail -->
    <div v-if="badgeMessage" :class="['badge', badgeType]">{{ badgeMessage }}</div>
  </div>
</template>


<script>
import ProfPepOverlay from '@/components/ProfPepOverlay.vue';
import MorningWinOverlay from '@/components/MorningWinOverlay.vue';
import MorningLoseOverlay from '@/components/MorningLoseOverlay.vue';
import NoonWinOverlay from '@/components/NoonWinOverlay.vue';
import NoonLoseOverlay from '@/components/NoonLoseOverlay.vue';
import AfternoonWinOverlay from '@/components/AfternoonWinOverlay.vue';
import AfternoonLoseOverlay from '@/components/AfternoonLoseOverlay.vue';
import EveningWinOverlay from '@/components/EveningWinOverlay.vue';
import EveningLoseOverlay from '@/components/EveningLoseOverlay.vue';
import { Howler } from 'howler';
import { sounds } from '@/utils/sounds';

export default {
  components: {
    ProfPepOverlay,
    MorningWinOverlay,
    MorningLoseOverlay,
    NoonWinOverlay,
    NoonLoseOverlay,
    AfternoonWinOverlay,
    AfternoonLoseOverlay,
    EveningWinOverlay,
    EveningLoseOverlay,
  },
  props: {
    suntime: {
      type: String,
      default: 'morning', // Fallback value
    },
    background: {
      type: String,
      default: '',
    },
    games: {
      type: [String, Array],
      default: '[]',
    },
  },
  data() {
    let parsedGames = [];

    // Check if games is defined and parseable
    if (this.games) {
      try {
        parsedGames = Array.isArray(this.games) ? this.games : JSON.parse(this.games);
      } catch (e) {
        console.error('Error parsing games prop:', e);
      }
    } else {
      console.warn('Games prop is undefined, initializing as empty array.');
    }
    return {
      back_label : {en:"Back", el:"Πίσω", it:"Indietro", ro:"Înapoi", uk:"Назад"},
      Round_label: {en:"Round", el:"Γύρος", it:"Round", ro:"Rundă", uk:"Раунд"},
      timeleft_label: {en: "Time left", el: "Χρόνος", it: "Tempo rimasto", ro: "Timp rămas", uk: "Залишився час"},
      score_label: {en:"Score", el:"Πόντοι", it:"Punteggio", ro:"Scor", uk:"Рахунок"},
      correct_label: {en:"Correct!", el:"Σωστά!", it:"Corretto", ro:"Corect!", uk:"Правильно!"},
      wrong_label: {en:"Wrong...", el:"Λάθος...", it:"Sbagliato", ro:"Greșit...", uk:"Неправильно..."},
      timeup_label: {en:"Time's Up!", el:"Τέλος χρόνου!", ro:"Timpul s-a terminat!", uk:"Час вичерпано!"},
      isSyncing: false,
      daypart: '', // Initialize daypart
      overlayMessage: {en:'This is the message',el:"Αυτό είναι το μήνυμα"},
      isOverlayVisible: true,
      isMorningWinOverlayVisible: false,
      isMorningLoseOverlayVisible: false,
      isNoonWinOverlayVisible: false,
      isNoonLoseOverlayVisible: false,
      isAfternoonWinOverlayVisible: false,
      isAfternoonLoseOverlayVisible: false,
      isEveningWinOverlayVisible: false,
      isEveningLoseOverlayVisible: false,
      gameList: parsedGames,

      backgroundImage: require('@/assets/game-backgrounds/background.jpg'),
      categories: {
        fat_oil_sugar_sweets: [
          { category: "fat_oil_sugar_sweets", name: {en:'cake', el:'κέικ', it:'torta', ro:'tort', uk:'торт'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cup cake', el:'καπ κέικ', it:'cup cake', ro:'tort de ceașcă', uk:'чашка торта'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cup_cake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'donuts', el:'ντόνατς', it:'ciambelle', ro:'gogoși', uk:'пончики'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/donuts.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'icecream', el:'παγωτό', it:'gelato', ro:'înghețată', uk:'морозиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/icecream.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/oil-1.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/oil-2.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/oil-3.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'raspberry pie ', el:'πίτα βατόμουρο', it:'torta di lamponi', ro:'placinta cu zmeura', uk:'малиновий пиріг'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/raspberry_pie.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'strawberry pie', el:'φραουλόπιτα', it:'fragola torta', ro:'placinta cu capsuni', uk:'полуничний пиріг'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/strawberry_pie.png') },

          { category: "fat_oil_sugar_sweets", name: {en:'french fries', el:'πατάτες τηγανητές', it:'patatine fritte', ro:'cartofi pai', uk:'картопля фрі'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/french_fries.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'baklava', el:'μπακλαβάς', it:'baklava', ro:'baklava', uk:'пахлава'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/baklava.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'brownie', el:'μπράουνι', it:'brownie', ro:'brownie', uk:'брауні'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/brownie.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'candy', el:'καραμέλα', it:'caramelle', ro:'bomboane', uk:'цукерки'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/candy.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cheesecake', el:'τσίζκεϊκ', it:'cheesecake', ro:'cheesecake', uk:'чізкейк'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cheesecake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'chocolate bar', el:'μπάρα σοκολάτας', it:'barretta di cioccolato', ro:'chocolate bar', uk:'плитка шоколаду'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/chocolate_bar.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'chocolate cake', el:'σοκολατένιο κέικ', it:'torta al cioccolato', ro:'tort ciocolata', uk:'шоколадний торт'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/chocolate_cake.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cookie.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'pudding', el:'πουτίγκα', it:'budino', ro:'budincă', uk:'пудинг'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/pudding.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'tiramisu', el:'τιραμισού', it:'tiramisù', ro:'tiramisu', uk:'тірамісу'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/tiramisu.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'pasta flora', el:'πάστα φλώρα', it:'pasta flora', ro:'pasta-flora', uk:'паста-флора'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/pasta-flora.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'waffle', el:'βάφλα', it:'waffle', ro:'vafa', uk:'вафельний'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/waffle.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cookie-1.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/cookie-2.png') },
          { category: "fat_oil_sugar_sweets", name: {en:'croissant', el:'κρουασάν', it:'croissant', ro:'croissant', uk:'круасан'}, src: require('@/assets/game-elements/fat_oil_sugar_sweets/croissant.png') },
        ],
        meat_fish_milk_eggs: [
          { category: "meat_fish_milk_eggs", name: {en:'cheese', el:'τυρί', it:'formaggio', ro:'brânză', uk:'сир'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/cheese.png') },
          { category: "meat_fish_milk_eggs", name: {en:'eggs', el:'αυγά', it:'uova', ro:'ouă', uk:'яйця'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/eggs.png') },
          { category: "meat_fish_milk_eggs", name: {en:'fish', el:'ψάρι', it:'pesce', ro:'peşte', uk:'риба'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/fish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'ham', el:'ζαμπόν', it:'prosciutto', ro:'șuncă', uk:'шинка'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/ham.png') },
          { category: "meat_fish_milk_eggs", name: {en:'lobster', el:'αστακός', it:'aragosta', ro:'homar', uk:'лобстер'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/lobster.png') },
          { category: "meat_fish_milk_eggs", name: {en:'meat', el:'κρέας', it:'carne', ro:'carne', uk:'м\'ясо'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/meat.png') },
          { category: "meat_fish_milk_eggs", name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/milk.png') },
          { category: "meat_fish_milk_eggs", name: {en:'salmon', el:'σολομός', it:'salmone', ro:'somon', uk:'лосось'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/salmon.png') },
          { category: "meat_fish_milk_eggs", name: {en:'shrimp', el:'γαρίδα', it:'gamberetti', ro:'crevetă', uk:'креветки'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/shrimp.png') },
        
          { category: "meat_fish_milk_eggs", name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/beef.png') },
          { category: "meat_fish_milk_eggs", name: {en:'trout', el:'πεστρόφα', it:'trota', ro:'păstrăv', uk:'форель'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/trout.png') },
          { category: "meat_fish_milk_eggs", name: {en:'meat', el:'κρέας', it:'carne', ro:'carne', uk:'м\'ясо'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/meat-2.png') },
          { category: "meat_fish_milk_eggs", name: {en:'fish', el:'ψάρι', it:'pesce', ro:'peşte', uk:'риба'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/fish-2.png') },
          { category: "meat_fish_milk_eggs", name: {en:'chicken', el:'κοτόπουλο', it:'pollo', ro:'pui', uk:'курка'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/chicken.png') },
          { category: "meat_fish_milk_eggs", name: {en:'white fish', el:'λευκό ψάρι', it:'pesce bianco', ro:'pește alb', uk:'біла риба'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/white fish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'turkey', el:'γαλοπούλα', it:'tacchino', ro:'curcan', uk:'індичка'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/turkey.png') },
          { category: "meat_fish_milk_eggs", name: {en:'swordfish', el:'ξιφίας', it:'pesce spada', ro:'pește-spadă', uk:'риба-меч'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/swordfish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'shellfish', el:'οστρακοειδή', it:'crostacei', ro:'crustacee', uk:'молюски'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/shellfish.png') },
          { category: "meat_fish_milk_eggs", name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/yogurt.png') },
          { category: "meat_fish_milk_eggs", name: {en:'ricotta cheese', el:'τυρί ρικότα', it:'ricotta', ro:'brânză ricotta', uk:'сир Рікотта'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/ricotta_cheese.png') },
          { category: "meat_fish_milk_eggs", name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: require('@/assets/game-elements/meat_fish_milk_eggs/beef-2.png') },

        ],
        fruits: [
          { category: "fruits", name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: require('@/assets/game-elements/fruits/apple.png') },
          { category: "fruits", name: {en:'banana', el:'μπανάνα', it:'banana', ro:'banană', uk:'банан'}, src: require('@/assets/game-elements/fruits/banana.png') },
          // { category: "fruits", name: {en:'coconut', el:'καρύδα', it:'cocco', ro:'nucă de cocos', uk:'кокосовий горіх'}, src: require('@/assets/game-elements/fruits/coconut.png') },
          { category: "fruits", name: {en:'dragonfruit', el:'φρούτο του δράκου', it:'frutto del drago', ro:'dragonfruit', uk:'бабовий плід'}, src: require('@/assets/game-elements/fruits/dragonfruit.png') },
          { category: "fruits", name: {en:'grapes', el:'σταφύλια', it:'uva', ro:'strugurii', uk:'виноград'}, src: require('@/assets/game-elements/fruits/grapes.png') },
          { category: "fruits", name: {en:'orange', el:'πορτοκάλι', it:'arancia', ro:'portocale', uk:'помаранчевий'}, src: require('@/assets/game-elements/fruits/orange.png') },
          { category: "fruits", name: {en:'papaya', el:'παπάγια', it:'papaya', ro:'papaya', uk:'папайя'}, src: require('@/assets/game-elements/fruits/papaya.png') },
          { category: "fruits", name: {en:'pear', el:'αχλάδι', it:'pera', ro:'pară', uk:'груша'}, src: require('@/assets/game-elements/fruits/pear.png') },
          { category: "fruits", name: {en:'pineapple', el:'ανανάς', it:'ananas', ro:'ananas', uk:'ананас'}, src: require('@/assets/game-elements/fruits/pineapple.png') },
          { category: "fruits", name: {en:'plum', el:'δαμάσκηνο', it:'prugna', ro:'prună', uk:'слива'}, src: require('@/assets/game-elements/fruits/plum.png') },
          { category: "fruits", name: {en:'pomegranate', el:'ρόδι', it:'melograno', ro:'rodie', uk:'гранат'}, src: require('@/assets/game-elements/fruits/pomegranate.png') },
          { category: "fruits", name: {en:'quince', el:'κυδώνι', it:'mela cotogna', ro:'gutui', uk:'айва'}, src: require('@/assets/game-elements/fruits/quince.png') },

          { category: "fruits", name: {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: require('@/assets/game-elements/fruits/apple-2.png') },
          { category: "fruits", name: {en:'apricot', el:'βερύκοκκο', it:'albicocca', ro:'caisă', uk:'абрикосовий'}, src: require('@/assets/game-elements/fruits/apricot.png') },
          { category: "fruits", name: {en:'cantaloupe', el:'πεπόνι', it:'melone cantalupo', ro:'pepene galben', uk:'канталупа'}, src: require('@/assets/game-elements/fruits/cantaloupe.png') },
          { category: "fruits", name: {en:'cherry', el:'κεράσι', it:'ciliegia', ro:'cireașă', uk:'вишня'}, src: require('@/assets/game-elements/fruits/cherry.png') },
          { category: "fruits", name: {en:'grapefruit', el:'γκρέιπφρουτ', it:'pompelmo', ro:'grapefruit', uk:'грейпфрут'}, src: require('@/assets/game-elements/fruits/grapefruit.png') },
          { category: "fruits", name: {en:'kiwi', el:'ακτινίδιο', it:'kiwi', ro:'kiwi', uk:'ківі'}, src: require('@/assets/game-elements/fruits/kiwi.png') },
          { category: "fruits", name: {en:'lychees', el:'λίτσι', it:'litchi', ro:'lychees', uk:'лічі'}, src: require('@/assets/game-elements/fruits/lychees.png') },
          { category: "fruits", name: {en:'nectarine', el:'νεκταρίνι', it:'nettarina', ro:'nectarina', uk:'нектарин'}, src: require('@/assets/game-elements/fruits/nectarine.png') },
          { category: "fruits", name: {en:'persimmon', el:'λωτός', it:'cachi', ro:'curmal japonez', uk:'хурма'}, src: require('@/assets/game-elements/fruits/persimmon.png') },
          { category: "fruits", name: {en:'plum', el:'δαμάσκηνο', it:'prugna', ro:'prună', uk:'слива'}, src: require('@/assets/game-elements/fruits/pluot.png') },
          { category: "fruits", name: {en:'strawberry', el:'φράουλα', it:'fragola', ro:'căpșună', uk:'полуниця'}, src: require('@/assets/game-elements/fruits/strawberry.png') },
          { category: "fruits", name: {en:'tangerines', el:'μανταρίνια', it:'mandarini', ro:'mandarine', uk:'мандарини'}, src: require('@/assets/game-elements/fruits/tangerines.png') },
          { category: "fruits", name: {en:'watermelon', el:'καρπούζι', it:'anguria', ro:'pepene verde', uk:'кавун'}, src: require('@/assets/game-elements/fruits/watermelon.png') },
          { category: "fruits", name: {en:'berries', el:'μούρα', it:'bacche', ro:'fructe de padure', uk:'ягоди'}, src: require('@/assets/game-elements/fruits/berries.png') },

        ],
        vegetables: [
          // { category: "vegetables", name: {en:'avocado', el:'αβοκάντο', it:'avocado', ro:'avocado', uk:'авокадо'}, src: require('@/assets/game-elements/vegetables/avocado.png') },
          { category: "vegetables", name: {en:'beetroot', el:'παντζάρι', it:'barbabietola', ro:'sfeclă', uk:'буряк'}, src: require('@/assets/game-elements/vegetables/beetroot.png') },
          { category: "vegetables", name: {en:'broccoli', el:'μπρόκολο', it:'broccoli', ro:'broccoli', uk:'брокколі'}, src: require('@/assets/game-elements/vegetables/broccoli.png') },
          { category: "vegetables", name: {en:'cabbage', el:'λάχανο', it:'cavolo', ro:'varză', uk:'капуста'}, src: require('@/assets/game-elements/vegetables/cabbage.png') },
          { category: "vegetables", name: {en:'carrot', el:'καρότο', it:'carota', ro:'morcov', uk:'морква'}, src: require('@/assets/game-elements/vegetables/carrot.png') },
          { category: "vegetables", name: {en:'celery', el:'σέλινο', it:'sedano', ro:'țelină', uk:'селера'}, src: require('@/assets/game-elements/vegetables/celery.png') },
          { category: "vegetables", name: {en:'corn', el:'καλαμπόκι', it:'mais', ro:'porumb', uk:'кукурудза'}, src: require('@/assets/game-elements/vegetables/corn.png') },
          { category: "vegetables", name: {en:'eggplant', el:'μελιτζάνα', it:'melanzane', ro:'vânătă', uk:'баклажани'}, src: require('@/assets/game-elements/vegetables/eggplant.png') },
          { category: "vegetables", name: {en:'garlic', el:'σκόρδο', it:'aglio', ro:'usturoi', uk:'часник'}, src: require('@/assets/game-elements/vegetables/garlic.png') },
          { category: "vegetables", name: {en:'leek', el:'πράσο', it:'porro', ro:'praz', uk:'цибуля-порей'}, src: require('@/assets/game-elements/vegetables/leek.png') },
          { category: "vegetables", name: {en:'lettuce', el:'μαρούλι', it:'lattuga', ro:'salată verde', uk:'листя салату'}, src: require('@/assets/game-elements/vegetables/lettuce.png') },
          { category: "vegetables", name: {en:'pepper', el:'πιπέρι', it:'peperone', ro:'piper', uk:'перець'}, src: require('@/assets/game-elements/vegetables/pepper.png') },
          { category: "vegetables", name: {en:'pumpkin', el:'κολοκύθι', it:'zucca', ro:'dovleac', uk:'гарбуз'}, src: require('@/assets/game-elements/vegetables/pumpkin.png') },
          { category: "vegetables", name: {en:'radish', el:'ραπανάκι', it:'ravanello', ro:'ridiche', uk:'редька'}, src: require('@/assets/game-elements/vegetables/radish.png') },
          { category: "vegetables", name: {en:'tomato', el:'ντομάτα', it:'pomodoro', ro:'roșie', uk:'помідор'}, src: require('@/assets/game-elements/vegetables/tomato.png') },
          { category: "vegetables", name: {en:'zucchini', el:'κολοκυθάκι', it:'zucchine', ro:'zucchini', uk:'цукіні'}, src: require('@/assets/game-elements/vegetables/zucchini.png') },
          
          { category: "vegetables", name: {en:'artichoke', el:'αγκινάρα', it:'carciofo', ro:'anghinare', uk:'артишок'}, src: require('@/assets/game-elements/vegetables/artichoke.png') },
          { category: "vegetables", name: {en:'arugula', el:'ρόκα', it:'rucola', ro:'voinicică', uk:'рукола'}, src: require('@/assets/game-elements/vegetables/arugula.png') },
          { category: "vegetables", name: {en:'beans', el:'φασόλια', it:'fagioli', ro:'fasole', uk:'квасоля'}, src: require('@/assets/game-elements/vegetables/beans.png') },
          { category: "vegetables", name: {en:'cucumber', el:'αγγούρι', it:'cetriolo', ro:'castravete', uk:'огірок'}, src: require('@/assets/game-elements/vegetables/cucumber.png') },
          { category: "vegetables", name: {en:'daikon', el:'ραπανάκι', it:'daikon', ro:'daikon', uk:'дайкон'}, src: require('@/assets/game-elements/vegetables/daikon.png') },
          { category: "vegetables", name: {en:'okra', el:'μπάμια', it:'gombo', ro:'baume', uk:'бамія'}, src: require('@/assets/game-elements/vegetables/okra.png') },
          { category: "vegetables", name: {en:'peas', el:'αρακάς', it:'piselli', ro:'mazăre', uk:'горох'}, src: require('@/assets/game-elements/vegetables/peas.png') },
          { category: "vegetables", name: {en:'potato', el:'πατάτα', it:'patata', ro:'cartof', uk:'картопля'}, src: require('@/assets/game-elements/vegetables/potato.png') },
          { category: "vegetables", name: {en:'spinach', el:'σπανάκι', it:'spinaci', ro:'spanac', uk:'шпинат'}, src: require('@/assets/game-elements/vegetables/spinach.png') },
          { category: "vegetables", name: {en:'turnip', el:'γογγύλι', it:'rapa', ro:'nap', uk:'ріпа'}, src: require('@/assets/game-elements/vegetables/turnip.png') },
        
        ],
        bread_cereals_pasta: [
          { category: "bread_cereals_pasta", name: {en:'baguette', el:'μπαγκέτα', it:'baguette', ro:'bagheta', uk:'багет'}, src: require('@/assets/game-elements/bread_cereals_pasta/baguette.png') },
          { category: "bread_cereals_pasta", name: {en:'black bread', el:'μαύρο ψωμί', it:'pane nero', ro:'pâine neagră', uk:'хліб чорний'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread black.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-1.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-2.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-3.png') },
          { category: "bread_cereals_pasta", name: {en:'bread', el:'ψωμί', it:'pane', ro:'pâine', uk:'хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/bread-4.png') },
          { category: "bread_cereals_pasta", name: {en:'breads', el:'ψωμιά', it:'pane', ro:'coș de pâine', uk:'кошик для хліба'}, src: require('@/assets/game-elements/bread_cereals_pasta/breads-basket.png') },
          { category: "bread_cereals_pasta", name: {en:'pasta', el:'ζυμαρικά', it:'pasta', ro:'paste', uk:'паста'}, src: require('@/assets/game-elements/bread_cereals_pasta/pasta.png') },
          { category: "bread_cereals_pasta", name: {en:'pretzel', el:'πρέτσελ', it:'pretzel', ro:'covrig', uk:'крендель'}, src: require('@/assets/game-elements/bread_cereals_pasta/pretzel.png') },
          { category: "bread_cereals_pasta", name: {en:'small bread', el:'ψωμάκι', it:'pane piccolo', ro:'pâine mică', uk:'дрібний хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/small-bread-1.png') },
          { category: "bread_cereals_pasta", name: {en:'small bread', el:'ψωμάκι', it:'pane piccolo', ro:'pâine mică', uk:'дрібний хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/small-bread-2.png') },
          
          { category: "bread_cereals_pasta", name: {en:'bagel', el:'κουλούρι', it:'bagel', ro:'covrigi', uk:'бублик'}, src: require('@/assets/game-elements/bread_cereals_pasta/bagel.png') },
          { category: "bread_cereals_pasta", name: {en:'barley', el:'κριθάρι', it:'orzo', ro:'orz', uk:'ячмінь'}, src: require('@/assets/game-elements/bread_cereals_pasta/barley.png') },
          { category: "bread_cereals_pasta", name: {en:'breadsticks', el:'κριτσίνια', it:'grissini', ro:'grisine', uk:'хлібні палички'}, src: require('@/assets/game-elements/bread_cereals_pasta/breadsticks.png') },
          { category: "bread_cereals_pasta", name: {en:'brioche', el:'τσουρέκι', it:'brioche', ro:'brioşă', uk:'бріош'}, src: require('@/assets/game-elements/bread_cereals_pasta/brioche.png') },
          { category: "bread_cereals_pasta", name: {en:'buckwheat', el:'φαγόπυρο', it:'grano saraceno', ro:'hrişcă', uk:'гречана крупа'}, src: require('@/assets/game-elements/bread_cereals_pasta/buckwheat.png') },
          { category: "bread_cereals_pasta", name: {en:'cornbread', el:'καλαμποκένιο ψωμί', it:'pane di mais', ro:'pâine de porumb', uk:'кукурудзяний хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/cornbread.png') },
          { category: "bread_cereals_pasta", name: {en:'cornflakes', el:'νιφάδες καλαμποκιού', it:'cornflakes', ro:'fulgi de porumb', uk:'кукурудзяні пластівці'}, src: require('@/assets/game-elements/bread_cereals_pasta/cornflakes.png') },
          { category: "bread_cereals_pasta", name: {en:'croutons', el:'κρουτόν', it:'crostini', ro:'crutoane', uk:'грінки'}, src: require('@/assets/game-elements/bread_cereals_pasta/croutons.png') },
          { category: "bread_cereals_pasta", name: {en:'fettuccine', el:'ταλιατέλες', it:'fettuccine', ro:'fettuccine', uk:'фетучіні'}, src: require('@/assets/game-elements/bread_cereals_pasta/fettuccine.png') },
          { category: "bread_cereals_pasta", name: {en:'flatbread', el:'ψωμί', it:'pane piatto', ro:'pâine plate', uk:'лепешка'}, src: require('@/assets/game-elements/bread_cereals_pasta/flatbread.png') },
          { category: "bread_cereals_pasta", name: {en:'focaccia', el:'ελαιόψωμο', it:'focaccia', ro:'focaccia', uk:'фокачча'}, src: require('@/assets/game-elements/bread_cereals_pasta/focaccia.png') },
          { category: "bread_cereals_pasta", name: {en:'granola', el:'γκρανόλα', it:'granola', ro:'granola', uk:'гранола'}, src: require('@/assets/game-elements/bread_cereals_pasta/granola.png') },
          { category: "bread_cereals_pasta", name: {en:'macaroni', el:'μακαρόνια', it:'maccheroni', ro:'macaroane', uk:'макарони'}, src: require('@/assets/game-elements/bread_cereals_pasta/macaroni.png') },
          { category: "bread_cereals_pasta", name: {en:'muesli', el:'μούσλι', it:'muesli', ro:'musli', uk:'мюслі'}, src: require('@/assets/game-elements/bread_cereals_pasta/muesli.png') },
          { category: "bread_cereals_pasta", name: {en:'naan', el:'σκορδόψωμο', it:'naan', ro:'naan', uk:'наан'}, src: require('@/assets/game-elements/bread_cereals_pasta/naan.png') },
          { category: "bread_cereals_pasta", name: {en:'noodles', el:'νουντλς', it:'noodles', ro:'tăiței', uk:'локшина'}, src: require('@/assets/game-elements/bread_cereals_pasta/noodles.png') },
          { category: "bread_cereals_pasta", name: {en:'penne', el:'πένες', it:'penne', ro:'penne', uk:'пенне'}, src: require('@/assets/game-elements/bread_cereals_pasta/penne.png') },
          { category: "bread_cereals_pasta", name: {en:'pita', el:'πίτα', it:'pita', ro:'pita', uk:'лаваш'}, src: require('@/assets/game-elements/bread_cereals_pasta/pita.png') },
          { category: "bread_cereals_pasta", name: {en:'quinoa', el:'κινόα', it:'quinoa', ro:'quinoa', uk:'кіноа'}, src: require('@/assets/game-elements/bread_cereals_pasta/quinoa.png') },
          { category: "bread_cereals_pasta", name: {en:'rice', el:'ρύζι', it:'riso', ro:'orez', uk:'рис'}, src: require('@/assets/game-elements/bread_cereals_pasta/rice.png') },
          { category: "bread_cereals_pasta", name: {en:'rye bread', el:'σικαλένιο ψωμί', it:'pane di segale', ro:'pâine de secară', uk:'житній хліб'}, src: require('@/assets/game-elements/bread_cereals_pasta/rye_bread.png') },
          { category: "bread_cereals_pasta", name: {en:'sourdough', el:'προζυμένιο ψωμί', it:'pasta madre', ro:'aluat', uk:'закваска'}, src: require('@/assets/game-elements/bread_cereals_pasta/sourdough.png') },
          { category: "bread_cereals_pasta", name: {en:'spaghetti', el:'μακαρόνια', it:'spaghetti', ro:'spaghete', uk:'спагетті'}, src: require('@/assets/game-elements/bread_cereals_pasta/spaghetti.png') },
        ],

      },
      foods: [],
      oddFood: null,
      round: 0,
      maxRounds: 9,
      score: 0,
      timeLeft: 10,
      timer: null,
      badgeMessage: '',
      badgeType: '',
      scoreThreshold: 50,
      language:'en',
      audio: null,
      roundLocked: false
    };
  },
  methods: {
    async goBack() {
      sounds.whoosh.play();
      if (sounds.food_game) {
        sounds.food_game.stop();
      }
      this.$router.push({ name: 'GameSelection' });
    },
    //   startGame() {
    //     this.round = 0;
    //     this.score = 0;
    //     this.nextRound();
    //   },
    startGame() {
      this.overlayMessage = {en:'Pick the odd among the foods! Be quick, time is running!', el:'Βρες το φαγητό που δεν ταιριάζει ανάμεσα στα υπόλοιπα! Γρήγορα, ο χρόνος τελειώνει!', it:'Scegli quello strano tra i cibi! Sii veloce, il tempo scorre!', ro:'Alege alimentul care nu se potrivește! Fii rapid, timpul trece!', uk:'Вибери зайве серед їжі! Швидше, час спливає!'}
      this.isOverlayVisible = true;
      // Do not set a timeout here; wait for button click from ProfPepOverlay
    },
    onStartGame() {
      // Resume Howler context for autoplay policies
      Howler.ctx.resume();
      // Hide the overlay and start the game logic
      this.isOverlayVisible = false;
      this.round = -1;
      this.score = 0;
      this.nextRound();

      // Play a sound
      sounds.start_sound.play();

      // Play background music after user interaction, with a short delay
      setTimeout(() => {
        sounds.food_game.play();
      }, 500);
    },
    async updateSeedPoints(seedType, change) {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const response = await fetch("https://erebus2.athenarc.gr/duse/update-seed-points", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ seedType, change }),
    });

    if (response.ok) {
      console.log(`Seed points updated: ${change} to ${seedType}`);
    } else {
      console.error("Failed to update seed points.");
    }
  } catch (error) {
    console.error("Error updating seed points:", error);
  }
},
    async endGame() {
      // Stop background music before playing win/lose sound
      if (sounds.food_game) {
        sounds.food_game.stop();
      }
      let seedType = "";
      let change = 0;

      if (this.score > this.scoreThreshold) {
        change = 1; // Win: Gain a seed
      } else {
        change = -1; // Lose: Lose a seed
      }

      if (this.score > this.scoreThreshold) {
        // Play a sound
        sounds.win_sound.play();
      } else {
        // Play a sound
        sounds.lose_sound.play();
      }
      if (this.daypart == 'morning') {
        seedType = "blue";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isMorningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'noon') {
        seedType = "red";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isNoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isNoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'afternoon') {
        seedType = "green";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isAfternoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isAfternoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'night') {
        seedType = "yellow";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isEveningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isEveningLoseOverlayVisible = true; // Show overlay at the end
        }
      }
      // Send seed update to the backend
      await this.updateSeedPoints(seedType, change);

      setTimeout(() => {
        this.$router.push({ name: 'GameSelection' }); // Redirect after delay
      }, 3000); // 3 seconds delay
    },
    nextRound() {
      if (this.round == this.maxRounds) {
        this.endGame();
        return;
      }
      this.round++;
      this.badgeMessage = '';
      this.timeLeft = 10;
      this.startTimer();

      const { primary, odd } = this.selectFoods();
      this.foods = this.shuffleArray([...primary, odd]);
      this.oddFood = odd;

      // Explicitly set foods before displaying them to avoid delay
      this.$nextTick(() => {
        // Force re-render of food items
        this.foods = [...this.foods];
      });
    },
    selectFoods() {
      const keys = Object.keys(this.categories);
      const primaryCategory = keys[Math.floor(Math.random() * keys.length)];
      const secondaryCategory = keys.filter(key => key !== primaryCategory)[Math.floor(Math.random() * (keys.length - 1))];

      const primaryFoods = this.categories[primaryCategory].slice(0, 3);
      const oddFood = this.categories[secondaryCategory][Math.floor(Math.random() * this.categories[secondaryCategory].length)];

      return { primary: primaryFoods, odd: oddFood };
    },
    shuffleArray(array) {
      return array.sort(() => Math.random() - 0.5);
    },
    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timeLeft -= 1;
        if (this.timeLeft <= 0) {
          clearInterval(this.timer);
          this.showBadge('fail', this.timeup_label[this.language]);
          // Add a delay before moving to the next round
          setTimeout(() => {
            this.nextRound();
          }, 1000); // 1-second delay to show the badge
        }
      }, 1000);
    },
    checkSelection(food) {
      if (this.roundLocked) return; // ignore extra clicks per round
      this.roundLocked = true;
      clearInterval(this.timer);
      if (food.src === this.oddFood.src) {
        this.score += this.timeLeft;
        this.showBadge('success', this.correct_label[this.language]);
        // Play a sound
        sounds.score_sound.play();
      } else {
        this.showBadge('fail', this.wrong_label[this.language]);
        // Play a sound
        sounds.wrong_sound.play();
      }
      setTimeout(() => {
        this.roundLocked = false;
        this.nextRound();
      }, 1000);
    },
    showBadge(type, message) {
      this.badgeType = type;
      this.badgeMessage = message;
    },


    async storeInIndexedDB(gameState) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);
    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("gameStates")) {
        db.createObjectStore("gameStates", { keyPath: "id", autoIncrement: true });
      }
    };

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      // Check for existing game state before saving
      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        const existingRecords = getAllRequest.result;
        const duplicate = existingRecords.find(
          (record) => record.gameName === gameState.gameName && record.datePlayed === gameState.datePlayed
        );

        if (!duplicate) {
          store.add(gameState);
        } else {
          console.warn("Duplicate game state detected. Skipping save.");
        }

        resolve();
      };

      getAllRequest.onerror = function (event) {
        reject("Error checking existing records:", event.target.error);
      };
    };

    request.onerror = function (event) {
      reject("Error opening IndexedDB:", event.target.error);
    };
  });
}
,

async getUnsyncedGameStates() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readonly");
      const store = transaction.objectStore("gameStates");

      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        resolve(getAllRequest.result);
      };
      getAllRequest.onerror = function (event) {
        reject("Error retrieving game states:", event.target.error);
      };
    };
  });
},

async deleteSyncedGameStates(syncedGames) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      syncedGames.forEach((game) => {
        store.delete(game.id); // Delete only specific records
      });

      resolve();
    };

    request.onerror = function (event) {
      reject("Error clearing IndexedDB:", event.target.error);
    };
  });
}
,
async syncWithMongo() {
  if (this.isSyncing) return; // Prevent duplicate sync
  this.isSyncing = true;

  const token = localStorage.getItem("token");
  if (!token) {
    console.error("User not authenticated. Cannot sync.");
    this.isSyncing = false;
    return;
  }

  try {
    const unsyncedGames = await this.getUnsyncedGameStates();
    if (unsyncedGames.length === 0) {
      console.log("No game states to sync.");
      this.isSyncing = false;
      return;
    }

    const response = await fetch("https://erebus2.athenarc.gr/duse/save-game-state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ gameStates: unsyncedGames }),
    });

    if (response.ok) {
      console.log("Game states synced successfully.");
      await this.deleteSyncedGameStates(unsyncedGames);
    } else {
      console.error("Failed to sync game states.");
    }
  } catch (error) {
    console.error("Error syncing with MongoDB:", error);
  } finally {
    this.isSyncing = false; // Ensure flag is reset
  }
},
    async saveGameState() {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  if (!username) {
    console.error("User not logged in. Cannot save game state.");
    return;
  }

  const gameState = {
    username,
    gameName: this.$route.name,
    score: this.score,
    datePlayed: new Date().toISOString(),
  };

  try {
    // Store in IndexedDB regardless of network status
    await this.storeInIndexedDB(gameState);

    if (navigator.onLine && token) {
      await this.syncWithMongo();
    } else {
      console.warn("No internet connection. Game state saved locally.");
    }
  } catch (error) {
    console.error("Error saving game state:", error);
  }
},

  },
  created()
  {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },
  mounted() {
  
  console.log("Current route path:", this.$route.path);

  const daypart = this.$route.path.split("/")[2] || "daypart";
  this.daypart = daypart;
  this.startGame();

  // Check for internet connectivity
  window.addEventListener("online", async () => {
    console.log("Back online! Syncing game states...");
    await this.syncWithMongo();
  });
},
  beforeUnmount() {
    clearInterval(this.timer);
    if (sounds.food_game) {
      sounds.food_game.stop();
    }
    this.saveGameState();
  },
  beforeRouteLeave(to, from, next) {
    // Save game state when the user navigates away
    if (sounds.food_game) {
      sounds.food_game.stop();
    }
    this.saveGameState();
    next();
  },
};
</script>
<style scoped>
/* Apply Arial font globally to all text */
* {
  font-family: 'Arial', sans-serif;
}

.game-stats {
  position: absolute;
  top: 70px;
  /* Distance from the top of the screen */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  /* Spacing between stats */
  flex-wrap: wrap;
  /* Allow wrapping to new line */
  color: white;
  font-size: 2vw;
  /* Responsive font size */
  text-align: center;
}

.game-info,
.timer,
.score {
  min-width: 80px;
  /* Minimum size for better readability */
  font-weight: bold;
  flex: 1;
  /* Allow equal distribution */
  text-align: center;
}

/* Media Query for Smaller Screens */
@media (max-width: 768px) {
  .game-stats {
    flex-direction: column;
    /* Stack stats vertically */
    gap: 10px;
    /* Reduce gap for small screens */
    font-size: 4vw;
    /* Adjust font size for smaller screens */
    top: 50px;
    /* Adjust vertical position */
  }
}

@media (max-width: 480px) {
  .game-stats {
    font-size: 5vw;
    /* Larger font for very small screens */
    gap: 5px;
    /* Smaller gap */
  }
}

.game-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

#food-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  color: white;
  font-size: 5vw;
}

.food-image {
  width: 120px;
  height: 120px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s;
}

.food-name {
  font-size: 4vmin;
  text-align: center;
  color: white;
}

.food-image:hover {
  transform: scale(1.1);
}

.badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}

.badge.success {
  background-color: green;
}

.badge.fail {
  background-color: red;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  z-index: 1001;
}

</style>